export default __webpack_public_path__ + "images/trash-modal-icon.svg";